import { Badge } from "primereact/badge";
import type { SchemaFieldOption } from "../../../../helpers/format-databases";
import type { ModalDialogProps } from "../../../../ui/shared/global-tools/dialog-system";

export interface ViewMoreOptionsDialogProps extends ModalDialogProps<void> {
  closeDialog: () => void;
  parameter: ViewMoreOptionsDialogParameter;
}

export interface ViewMoreOptionsDialogParameter {
  options: SchemaFieldOption[];
  fieldName: string;
}

export default function makeViewMoreOptionsDialog({
  parameter: { options, fieldName },
}: ViewMoreOptionsDialogProps) {
  const content = (
    <div>
      {options.map((o) => (
        <Badge key={o.key} value={o.value} severity="info" className="mr-1" />
      ))}
    </div>
  );

  return { header: `Options du champ '${fieldName}'`, content };
}
